// extracted by mini-css-extract-plugin
module.exports = {"UsersList__item":"UsersList_UsersList__item__2Pwir"};